import { deleteCookie } from "globalservices/cookie";
import { getQueryStringKeys } from "globalutils/fmUtils";
import { resolveSpireonNewPostLoginPath, shouldUseSpireonNewRoutes } from '../fleetLocateLoginUtils';
import { setLocalStorage } from 'globalservices/storage';

export const getRedirectionURL = (search, key) => getQueryStringKeys(search, key);

export const handleLoginWithToken = (history, fetchLogin, clearRedux, COOKIE_AUTH_DETAILS) => {
    const newClientToken = getQueryStringKeys(history.location.state.search, 'token');
    const isNauto = window.$environment.SERVICE_PROVIDER === 'nauto';

    const data = {
        token: newClientToken,
        ...(isNauto && {
            "company-id": getQueryStringKeys(history.location.state.search, 'company-id'),
            "group-id": getQueryStringKeys(history.location.state.search, 'group-id'),
            "callback-url": getQueryStringKeys(history.location.state.search, 'callback-url'),
        }),
    };

    if (newClientToken) {
        deleteCookie(COOKIE_AUTH_DETAILS);
        clearRedux();
        fetchLogin({
            apiId: 'handleLogin',
            data,
            callback: (type, message) => {
                if (type === 'mfaEnabled') {
                    history.push('/user/mfa');
                } else if (type === 'error' && message === 'permission denied') {
                    history.push({
                        pathname: history.location.state?.referrer,
                        search: history.location.state?.search,
                        state: { error: 'permission denied' },
                    });
                } else {
                    if (shouldUseSpireonNewRoutes(history.location.pathname)) {
                        setLocalStorage('currentLayout', window.$environment.APP_LAYOUT || 'SpireonNew');
                    }
                    history.push(
                        shouldUseSpireonNewRoutes(history.location.pathname)
                            ? resolveSpireonNewPostLoginPath(history.location.state?.referrer)
                            : '/'
                    );
                }
            },
        });
    }
};


/**
 * Handles login callback redirect logic
 * @param {Object} params - Parameters object
 * @param {Object} params.out - Login response from API
 * @param {Object} params.history - React Router history object
 * @param {string} [params.redirectedFromFleetops] - Optional FleetOps redirect URL
 * @param {string} [params.redirectedUrlsValue] - Optional custom redirect URL
 * @param {string} [params.errorMessage] - Optional custom error message for failed login
 */
export const handleLoginCallback = ({
    out,
    history,
    redirectedFromFleetops,
    redirectedUrlsValue,
    errorMessage = 'Login failed',
}) => {
    // Handle failed login
    if (!out) {
        console.error(errorMessage);
        return;
    }

    // Handle MFA
    if (out === 'mfaEnabled') {
        history.push('/user/mfa');
        return;
    }

    // Determine base redirect URL
    let redirectUrl = '/';
    if (window.$environment.SERVICE_PROVIDER === 'eldx') {
        redirectUrl = window.$environment.RESELLER;
    }

    // Handle FleetOps redirect
    if (redirectedFromFleetops) {
        const redirectionURL = new URL(redirectedFromFleetops);
        redirectionURL.searchParams.set('token', out.token);
        redirectionURL.searchParams.set('partnerId', window.$environment?.DOMAIN);
        redirectUrl = redirectionURL.toString();
    }
    // Handle custom redirect URL
    else if (redirectedUrlsValue) {
        redirectUrl = redirectedUrlsValue;
    }

    // Check if redirect URL is external (different origin)
    try {
        const redirectUrlObj = new URL(redirectUrl, window.location.origin);
        const isExternal = redirectUrlObj.origin !== window.location.origin;

        if (isExternal) {
            // External URL - use full page redirect
            window.location.href = redirectUrl;
        } else {
            // Internal URL - use React Router for smooth navigation
            const path = redirectUrlObj.pathname + redirectUrlObj.search + redirectUrlObj.hash;
            history.push(path);
        }
    } catch (error) {
        // If URL parsing fails, treat as relative path and use history.push
        history.push(redirectUrl);
    }
};